import React from 'react';
import { AdminRouteName } from '../CONSTANTS';
import LoansTableRecords from './LoansTableRecords';

const AllLoans = () => (
  <LoansTableRecords defaultUrl={AdminRouteName.loansRoute} toggleStorageId="all_loans-table-col" hasNameAndImage permissionName="can-view-all-credit-request-tab" />
);
export default AllLoans;
